import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/(app)/city-clerk/$id/permits')({
  component: RouteComponent,
})
function RouteComponent() {
  return <div>Hello "/city-clerk/$id/permits"!</div>
}
